import styled from 'styled-components/macro';
import { Tab } from 'ui-component-library';

export const LateBadgeContainer = styled.div`
  background-color: ${(props) => props.theme.palette.orange[100]};
  border-radius: 8px;
  width: 70px;
`;

export const CustomTab = styled(Tab)`
  && {
    height: 40px;
    padding-top: 10px;
  }
`;
